/**
 * Devices to point out on the map, handed over in the router state (`navigate('/map', { state: { highlight } })`):
 * e.g. a group of the placement review. Positions travel with the request, so the map needs no lookup; `returnTo`
 * is where the banner's back button leads (with its router state, e.g. the review to reopen).
 */
export interface MapHighlight {
  label: string;
  points: { id: string; name: string; lon: number; lat: number }[];
  /** `label`: the back button's text (default "Back to review") */
  returnTo?: { path: string; state?: unknown; label?: string };
}

export function highlightOf(state: unknown): MapHighlight | null {
  const h = (state as { highlight?: MapHighlight } | null)?.highlight;
  return h && Array.isArray(h.points) && h.points.length ? h : null;
}

/** [[west, south], [east, north]] of the points. */
export function highlightBounds(h: MapHighlight): [[number, number], [number, number]] {
  const lons = h.points.map((p) => p.lon);
  const lats = h.points.map((p) => p.lat);
  return [
    [Math.min(...lons), Math.min(...lats)],
    [Math.max(...lons), Math.max(...lats)],
  ];
}
